import { z } from "zod";
import { AgencyIdSchema, ClientLinkIdSchema, ProjectIdSchema, } from "../primitives/ids.js";
import { ClientLinkStatusSchema } from "./client-link.js";
import { PrimaryEvidenceTypeSchema } from "./business-profile-readiness.js";
const IntakeServiceAreaSchema = z.object({ id: z.string().min(1).optional(), name: z.string().min(1).max(120) }).strict();
const IntakeServiceSchema = z.object({ id: z.string().min(1).optional(), name: z.string().min(1).max(120) }).strict();
export const ClientIntakeEvidenceFileV1Schema = z
    .object({
    fileId: z.string().min(1).max(80),
    fileName: z.string().min(1).max(200),
    contentType: z.string().min(1).max(120),
    sizeBytes: z.number().int().min(0).max(50_000_000),
})
    .strict();
export const ClientIntakeSubmitRequestV1Schema = z
    .object({
    schemaVersion: z.literal("client-intake-submit.v1.0"),
    businessName: z.string().min(1).max(160),
    primaryPhone: z.string().max(80).optional(),
    primaryEmail: z.string().email().optional(),
    description: z.string().max(2000).optional(),
    services: z.array(IntakeServiceSchema).max(50).default([]),
    serviceAreas: z.array(IntakeServiceAreaSchema).max(25).default([]),
    primaryEvidenceType: PrimaryEvidenceTypeSchema.optional(),
    evidenceFiles: z.array(ClientIntakeEvidenceFileV1Schema).max(20).optional(),
})
    .strict();
export const ClientIntakeDraftSaveRequestV1Schema = z
    .object({
    schemaVersion: z.literal("client-intake-draft-save.v1.0"),
    businessName: z.string().min(1).max(160).optional(),
    primaryPhone: z.string().max(80).optional(),
    primaryEmail: z.string().max(80).optional(),
    description: z.string().max(2000).optional(),
    services: z.array(IntakeServiceSchema).max(50).optional(),
    serviceAreas: z.array(IntakeServiceAreaSchema).max(25).optional(),
    primaryEvidenceType: PrimaryEvidenceTypeSchema.optional(),
    evidenceFiles: z.array(ClientIntakeEvidenceFileV1Schema).max(20).optional(),
})
    .strict();
export const ClientIntakeSubmissionStatusSchema = z.enum(["DRAFT", "SUBMITTED"]);
export const ClientIntakeViewV1Schema = z
    .object({
    schemaVersion: z.literal("client-intake-view.v1.0"),
    clientLinkId: ClientLinkIdSchema,
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    status: ClientIntakeSubmissionStatusSchema,
    linkStatus: ClientLinkStatusSchema,
    businessName: z.string().min(1),
    primaryPhone: z.string().optional(),
    primaryEmail: z.string().optional(),
    description: z.string().optional(),
    services: z.array(IntakeServiceSchema),
    serviceAreas: z.array(IntakeServiceAreaSchema),
    primaryEvidenceType: PrimaryEvidenceTypeSchema.optional(),
    evidenceFiles: z.array(ClientIntakeEvidenceFileV1Schema).default([]),
    submittedAt: z.string().datetime().nullable(),
    updatedAt: z.string().datetime(),
})
    .strict();
export const ClientIntakeDraftSaveResultV1Schema = z
    .object({
    schemaVersion: z.literal("client-intake-draft-save-result.v1.0"),
    intake: ClientIntakeViewV1Schema,
    linkStatus: ClientLinkStatusSchema,
})
    .strict();
export const ClientIntakeSubmitResultV1Schema = z
    .object({
    schemaVersion: z.literal("client-intake-submit-result.v1.0"),
    intake: ClientIntakeViewV1Schema,
    linkStatus: ClientLinkStatusSchema,
})
    .strict();
export const StudioIntakeSummaryV1Schema = z
    .object({
    schemaVersion: z.literal("studio-intake-summary.v1.0"),
    clientLinkId: ClientLinkIdSchema,
    projectId: ProjectIdSchema,
    status: ClientIntakeSubmissionStatusSchema,
    linkStatus: ClientLinkStatusSchema,
    businessName: z.string().min(1),
    primaryPhone: z.string().optional(),
    primaryEmail: z.string().optional(),
    description: z.string().optional(),
    primaryEvidenceType: PrimaryEvidenceTypeSchema.optional(),
    services: z.array(IntakeServiceSchema).optional(),
    serviceAreas: z.array(IntakeServiceAreaSchema).optional(),
    serviceCount: z.number().int().min(0),
    serviceAreaCount: z.number().int().min(0),
    submittedAt: z.string().datetime().nullable(),
    updatedAt: z.string().datetime(),
})
    .strict();
export const StudioIntakeDraftFromIntakeRequestV1Schema = z
    .object({
    schemaId: z.literal("studio-intake.draftFromIntakeRequest.v1"),
    clientLinkId: ClientLinkIdSchema,
})
    .strict();
//# sourceMappingURL=client-intake.js.map